export const api_url = process.env.NODE_ENV === 'production' ? '' : 'http://jolt-lens.localhost';

